import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import RGL, { WidthProvider } from "react-grid-layout";
import { useDispatch, useSelector } from "react-redux";
import Langs from "../../app/lang/langs";
import {
  checkPermission,
  isOwner,
  isAdmin
} from "../../app/utils/helpers";
import addIcon from "../../assets/images/add.png";
import addIconFocus from "../../assets/images/addFocus.png";
import deleteIcon from "../../assets/images/delete.png";
import deleteIconFocus from "../../assets/images/delete-orange.png";
import xIcon from "../../assets/images/reject.png";
import xIconFocus from "../../assets/images/rejectDanger.png";
import checkIcon from "../../assets/images/check.png";
import checkIconFocus from "../../assets/images/checkSuccess.png"
import editIcon from "../../assets/images/edit.png";
import editIconFocus from "../../assets/images/editFocus.png";
import ImageButton from "../../components/buttons/ImageButton";
import { ShiftCell } from "../../components/scheduler/cells/shiftCell.js";
import { ShiftFormModal } from "../../components/scheduler/forms/ShiftFormModal.js";
import { generateSampleLeave } from "../../components/scheduler/leave/leaveSampleSlice";
import { hideFormPopup, setShowFormPopup } from "../planning/planningSlice";
import {
  getSettings,
} from "./settingsSlice";
import styles from "./Settings.module.css";
import {
  getHolidays,
} from "./settingsSlice";
import { config } from "../../app/utils/config.js";
import {
  addEvaluationField,
  deleteEvaluationField,
  setAddFieldResponse,
  setDeleteFieldResponse,
  reorderEvaluationsFields,
  reorderEvaluationTypes,
  setTypeModalVisibilty,
  setFieldModalVisibilty,
  setOnEditField,
  getEvaluationFields,
  getEvaluationsTypes,
  setOnEditType,
  setModifyTypeResponse,
  setSaveTypeConfigResponse
} from "../../components/evaluations/evaluationsSlice.js";
import { showErrorToast, showSuccessToast } from "../../app/utils/helpers";
import { Dialog } from "primereact/dialog";
import { DynamicButton } from "../../components/buttons/DynamicButton.js";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import EvaluationTypeModal from "./Modals/EvaluationTypeModal.js";
import EvaluationFieldModal from "./Modals/EvaluationFieldModal.js";
import PostesTab from "./PostesTab"
import SkillsTab from "./SkillsTab.js";
import GeneralSettingsTab from "./GeneralSettingsTab.js";
import ClientSettingsTab from "./ClientSettingsTab.js";
import ShiftTemplatesTab from "./ShiftTemplatesTab.js";
import HolidaysTab from "./HolidaysTab.js";
import MobileSettingsView from "./mobile/MobileSettingsView";
import MobileGeneralSettingsTab from "./mobile/MobileGeneralSettingsTab";
import MobileShiftTemplatesTab from "./mobile/MobileShiftTemplatesTab";
import MobilePostesTab from "./mobile/MobilePostesTab";
import MobileSkillsTab from "./mobile/MobileSkillsTab";
const ReactGridLayout = WidthProvider(RGL);
const pjson = require('../../../package.json');

export function SettingsView() {

  const dispatch = useDispatch()

  const sampleLeavesRef = useRef()
  const mobileAddRef = useRef(null)

  const settings = useSelector((state) => state.settings)
  // const headerAction = useSelector((state) => state.common.headerAction)
  const sampleLeaves = useSelector((state) => state.sampleLeaves.list)
  const showFormPopup = useSelector((state) => state.planning.showFormPopup)
  const userRoleId = useSelector((state) => state.login.userRoleId)
  const permissions = useSelector((state) => state.login.permissions)
  const allEvaluationFields = useSelector((state) => state.evaluations.fieldsIgnoreActive)
  const deleteEvaluationFieldResponse = useSelector((state) => state.evaluations.deleteFieldResponse)
  const addEvaluationFieldResponse = useSelector((state) => state.evaluations.addFieldResponse)
  const evaluationsTypes = useSelector((state) => state.evaluations.typesIgnoreActive)
  const modifyTypeResponse = useSelector((state) => state.evaluations.modifyTypeResponse)
  const saveTypeConfigResponse = useSelector((state) => state.evaluations.saveTypeConfigResponse)
  const isMobile = useSelector((state) => state.settings.isMobile)

  const [menuList, setMenuList] = useState([])

  const [selectedMenu, setSelectedMenu] = useState(0)

  const [onAddEvaluationRowVisibility, setOnAddEvaluationRowVisibility] = useState(false)
  const [evaluationFieldTitle, setEvaluationFieldTitle] = useState("")
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false)
  const [deleteFieldId, setDeleteFieldId] = useState(null)
  const [orderedFields, setOrderedFields] = useState()
  const [orederedTypes, setOrderedTypes] = useState(evaluationsTypes)
  const [selectedEvaluationTypeLocal, setSelectedEvaluationTypeLocal] = useState()

  const dtFields = useRef(null)
  const dtTypes = useRef(null)

  const mounted = useRef(null)

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true
      dispatch(getHolidays({ year: settings.selectedYear }))
    }
  })

  useEffect(() => {
    if (deleteEvaluationFieldResponse != null) {
      if (deleteEvaluationFieldResponse.trim().toLowerCase().includes("successfully")) {
        showSuccessToast("Success!")
      } else {
        showErrorToast(deleteEvaluationFieldResponse)
      }
      if (selectedEvaluationTypeLocal) {
        dispatch(getEvaluationFields({ idType: selectedEvaluationTypeLocal.id }))
      }
      dispatch(setDeleteFieldResponse(null))
    }
  }, [deleteEvaluationFieldResponse])

  useEffect(() => {
    if (addEvaluationFieldResponse != null) {
      if (addEvaluationFieldResponse.trim().toLowerCase().includes("successfully")) {
        showSuccessToast("Success!")
      } else {
        showErrorToast(addEvaluationFieldResponse)
      }
      if (selectedEvaluationTypeLocal) {
        dispatch(getEvaluationFields({ idType: selectedEvaluationTypeLocal.id }))
      }
      dispatch(setAddFieldResponse(null))
    }
  }, [addEvaluationFieldResponse])

  useEffect(() => {
    if (saveTypeConfigResponse != null) {
      if (saveTypeConfigResponse.trim().toLowerCase().includes("successfully")) {
        showSuccessToast("Success!")
      } else {
        showErrorToast(saveTypeConfigResponse)
      }
      dispatch(setSaveTypeConfigResponse(null))
    }
  }, [saveTypeConfigResponse])

  useEffect(() => {
    if (modifyTypeResponse != null) {
      if (modifyTypeResponse.trim().toLowerCase().includes("successfully")) {
        showSuccessToast("Success!")
      } else {
        showErrorToast(modifyTypeResponse)
      }
      dispatch(getEvaluationsTypes())
      dispatch(setModifyTypeResponse(null))
    }
  }, [modifyTypeResponse])

  useEffect(() => {
    let menuList = [];

    if (checkPermission(config.scopes.settings, config.permissionTypes.edit)) {
      menuList = [
        "Réglages généraux",
        //"Réglages clients",
        "Modèles d'horaires",
        "Jours fériés",
      ]
    } else if (checkPermission(config.scopes.settings, config.permissionTypes.edit)) {
      menuList = [
        "Réglages généraux",
        //"Réglages clients",
        "Jours fériés",
      ]
    } else {
      menuList = [
        "Réglages généraux",
        "Jours fériés",
      ]
    }

    if (isOwner(userRoleId) || checkPermission(config.scopes.settings, config.permissionTypes.edit)) {
      menuList.push("Postes")
    }
    if (isOwner(userRoleId) || checkPermission(config.scopes.settings, config.permissionTypes.edit)) {
      menuList.push("Questionnaire d'évaluations")
      menuList.push("Compétence")
    }

    setMenuList(menuList)
    dispatch(getSettings())
  }, [dispatch, userRoleId, permissions])

  useEffect(() => {
    if (selectedMenu === menuList.indexOf("Questionnaire d'évaluations")) {
      dispatch(getEvaluationsTypes())
      if (selectedEvaluationTypeLocal) {
        dispatch(getEvaluationFields({ idType: selectedEvaluationTypeLocal.id }))
      }
    }
  }, [selectedMenu, selectedEvaluationTypeLocal, menuList])


  useEffect(() => {
    if (selectedEvaluationTypeLocal)
      setOrderedFields(allEvaluationFields)
  }, [allEvaluationFields])

  useEffect(() => {
    setOrderedTypes(evaluationsTypes)
  }, [evaluationsTypes])



  const handleAddSampleLeave = (event) => {
    let heureDebut = 9, heureFin = 17
    Object.values(settings.settingsList).map(item => {
      if (item.label === "Heure début de journée") heureDebut = item.settingValue
      if (item.label === "Heure fin de journée") heureFin = item.settingValue
    })
    dispatch(
      setShowFormPopup({
        type: "ADD_SAMPLE_LEAVE",
        data: generateSampleLeave(heureDebut, heureFin),
      })
    )
  }

  function constructLayoutForSampleLeaves() {
    let layout = []
    for (let i = 0; i < sampleLeaves.length; i++) {
      let leave = sampleLeaves[i];
      layout.push({
        i: leave["id"],
        x: i,
        y: 0,
        w: 1,
        h: 1,
        maxH: 1,
        minH: 1,
        data: leave,
      })
    }
    return layout
  }

  const handleAddEvaluationFieldVisibility = () => {
    setOnAddEvaluationRowVisibility(true);
  }

  const handleDeleteEvaluationField = (id) => {
    if (isAdmin(userRoleId) && deleteFieldId != null) {
      dispatch(deleteEvaluationField({ field_id: id }))
      setConfirmDeleteDialog(false);
      setDeleteFieldId(null)
    }
  }

  const handleAddEvaluationField = () => {
    if (isAdmin(userRoleId) && selectedEvaluationTypeLocal) {
      dispatch(addEvaluationField({ title: evaluationFieldTitle, idType: selectedEvaluationTypeLocal.id, rank: allEvaluationFields.length }));
      handleCancelAddField()
    }
  }

  const handleCancelAddField = () => {
    setEvaluationFieldTitle('')
    setOnAddEvaluationRowVisibility(false)
  }

  function renderAddEvaluationRow() {
    if (onAddEvaluationRowVisibility) {
      return (
        <Col lg={12} className="row mx-auto py-3 border-bottom pe-4 ms-3 me-4" style={{ backgroundColor: "#d6f1d6" }}>
          <Col lg={6} className="ps-0 my-auto">
            <input
              className="form-control"
              value={evaluationFieldTitle}
              onChange={(e) => { setEvaluationFieldTitle(e.target.value) }}
            />
          </Col>
          <Col lg={6} className="d-flex justify-content-end align-items-center pe-4">
            {evaluationFieldTitle.trim() != '' &&
              <ImageButton
                image={checkIcon}
                imageFocus={checkIconFocus}
                onClick={() => { handleAddEvaluationField() }}
                tooltip={<Langs str="ADD" />}
                active={true}
                width={32}
              />}
            <ImageButton
              image={xIcon}
              imageFocus={xIconFocus}
              onClick={() => { handleCancelAddField() }}
              tooltip={<Langs str="CANCEL" />}
              active={true}
              width={22}
            />
          </Col>
        </Col>
      )
    }
  }

  const handleReorderFields = (e) => {
    const { value } = e;
    let reorderedFields = [...value]
    reorderedFields = reorderedFields.map((field, index) => ({
      ...field,
      rank: index
    }));
    const requestArray = reorderedFields.map(field => ({
      id: field.id,
      rank: field.rank
    }));
    dispatch(reorderEvaluationsFields(requestArray))
    setOrderedFields(reorderedFields);
  }

  const handleReorderTypes = (e) => {
    const { value } = e;
    let reorderedTypes = [...value]
    reorderedTypes = reorderedTypes.map((type, index) => ({
      ...type,
      rank: index
    }));
    const requestArray = reorderedTypes.map(type => ({
      id: type.id,
      rank: type.rank
    }));
    dispatch(reorderEvaluationTypes(requestArray))
    setOrderedTypes(reorderedTypes);
  }

  const handleEditField = (rowData) => {
    return (
      <div className="d-flex justify-content-end">
        <ImageButton
          image={editIcon}
          imageFocus={editIconFocus}
          onClick={() => { dispatch(setFieldModalVisibilty(true)); dispatch(setOnEditField(rowData.id)) }}
          tooltip={<Langs str="EDIT" />}
          active={true}
          width={30}
        />
        <ImageButton
          image={deleteIcon}
          imageFocus={deleteIconFocus}
          onClick={() => { setConfirmDeleteDialog(true); setDeleteFieldId(rowData.id) }}
          tooltip={<Langs str="Delete" />}
          active={true}
          width={30}
        />
      </div>
    )
  }

  const handleEditType = (rowData) => {
    return (
      <div className="d-flex justify-content-end">
        <ImageButton
          image={editIcon}
          imageFocus={editIconFocus}
          onClick={() => { dispatch(setTypeModalVisibilty(true)); dispatch(setOnEditType(rowData.id)) }}
          tooltip={<Langs str="EDIT" />}
          active={true}
          width={32}
        />
      </div>
    )
  }

  const rowClass = (rowData) => {
    if (rowData) {
      if (rowData.active) {
        return styles.rowShadeGreen
      }
      return styles.rowShadeRed
    }
  }

  const typeBody = (rowData) => {
    if (rowData) {
      return (
        <span>
          {rowData.title}
        </span>
      )
    }
  }

  const handleTypeRowClick = (event) => {
    if (Array.isArray(event.value)) {
      setSelectedEvaluationTypeLocal(event.value[0])
    } else {
      setSelectedEvaluationTypeLocal(event.value)
    }
  }

  function renderEvaluationTypes() {
    return (
      <div>
        <DataTable ref={dtTypes}
          value={orederedTypes}
          reorderableRows
          onRowReorder={(e) => handleReorderTypes(e)}
          dataKey="id"
          scrollable
          scrollHeight="calc(100vh - 185px)"
          sortMode="single"
          sortField="rank"
          selectionMode="single"
          rowClassName={rowClass}
          selection={selectedEvaluationTypeLocal}
          onSelectionChange={handleTypeRowClick}
        >
          <Column rowReorder style={{ width: '3rem' }} />
          <Column field="title" body={typeBody} header={<Langs str="TYPE" />}></Column>
          <Column field="id" body={handleEditType} alignFrozen="right" frozen={true}></Column>
        </DataTable>
      </div>
    )
  }

  // Read-only marker; the flag is edited in EvaluationFieldModal alongside the title.
  // Worth surfacing in the list because it is the one field property that changes other
  // people's primes.
  const teamImpactBody = (row) => {
    if (Number(row.team_impact) !== 1) return null
    return (
      <span className="badge bg-warning text-dark">
        <Langs str="EVAL_FIELD_TEAM_IMPACT" />
      </span>
    )
  }

  function renderEvaluationFields() {
    return (
      <div>
        <DataTable ref={dtFields}
          value={orderedFields}
          reorderableRows
          onRowReorder={(e) => handleReorderFields(e)}
          dataKey="id"
          scrollable
          scrollHeight="calc(100vh - 300px)"
          sortMode="single"
          sortField="rank"
          rowClassName={rowClass}
        >
          <Column rowReorder style={{ width: '3rem' }} />
          <Column field="title" header={<Langs str="Question" />}></Column>
          <Column
            field="team_impact"
            header={<Langs str="EVAL_FIELD_TEAM_IMPACT" />}
            style={{ width: '9rem' }}
            body={teamImpactBody}
          ></Column>
          <Column field="id" body={handleEditField} alignFrozen="right" frozen={true}></Column>
        </DataTable>
      </div>
    )
  }

  function renderConfirmDeleteDialog() {
    let field = allEvaluationFields.find(field => field.id === deleteFieldId);
    return (

      <Dialog draggable={false} header="Confirmation" visible={confirmDeleteDialog} style={{ width: '30vw' }} onHide={() => { setConfirmDeleteDialog(false); setDeleteFieldId(null) }}>
        <Row className="d-flex justify-content-center">
          <Col lg={12} className="my-4 d-flex justify-content-center">
            <Langs str="DELETE_QUESTION" />:
          </Col>
          <Col lg={12} className="mb-4 d-flex justify-content-center text-center">
            <b>{field && field.title}</b>
          </Col>
          <Col lg={12} className="d-flex justify-content-center text-danger text-center">
            &#x26A0; <Langs str='FIELD_DELETE_QUESTION_MESSAGE' />
          </Col>
          <Col lg={3} className="my-3 mt-4">
            <DynamicButton
              onClick={() => handleDeleteEvaluationField(deleteFieldId)}
              className=''
              title={<Langs str="DELETE" />}
              active={true}
              color="red"
            />
          </Col>
        </Row>
      </Dialog>
    )
  }

  const handleEvaluationTypeChange = (e) => {
    setSelectedEvaluationTypeLocal(e.value)
  }

  const handleMenuChange = (selectedList) => {
    setSelectedMenu(selectedList[0])
  }

  const handleMenuChangeV2 = (e) => {
    setSelectedMenu(e.value)
  }

  let sampleLeavesLayout = constructLayoutForSampleLeaves()

  // Determine if the add button should show on mobile
  const showMobileAddButton = isOwner(userRoleId) && (
    menuList[selectedMenu] === "Postes" ||
    menuList[selectedMenu] === "Compétence" ||
    menuList[selectedMenu] === "Modèles d'horaires"
  )


  function renderMobileContent() {
    if (selectedMenu === menuList.indexOf("Réglages généraux"))
      return <MobileGeneralSettingsTab />
    else if (selectedMenu === menuList.indexOf("Modèles d'horaires"))
      return <MobileShiftTemplatesTab mobileAddRef={mobileAddRef} />
    else if (selectedMenu === menuList.indexOf("Jours fériés"))
      return <div style={{ marginTop: -90 }}><HolidaysTab menuLabel={menuList[selectedMenu]} /></div>
    else if (selectedMenu === menuList.indexOf("Postes"))
      return <MobilePostesTab mobileAddRef={mobileAddRef} />
    else if (selectedMenu === menuList.indexOf("Compétence"))
      return <MobileSkillsTab mobileAddRef={mobileAddRef} />
    return null
  }

  function renderMenuContent() {
    if (selectedMenu === menuList.indexOf("Réglages généraux")) {
      return <GeneralSettingsTab />
    }
    else if (selectedMenu === menuList.indexOf("Réglages clients"))
      return <ClientSettingsTab />
    else if (selectedMenu === menuList.indexOf("Modèles d'horaires"))
      return <ShiftTemplatesTab menuLabel={menuList[selectedMenu]} />
    else if (selectedMenu === menuList.indexOf("Congés"))
      return <Row className="m-0">
        <Col xxl={1}>
        </Col>
        <Col xxl={8} className="d-flex align-content-center">
          <div className={styles.menuContent}>
            <Row className="p-2">
              <Col
                xl={6}
                className="d-flex justify-content-start align-items-center p-2 ps-4">
                <label className={styles.menuHeaderTitle}>
                  <Langs str={menuList[selectedMenu]} />
                </label>
              </Col>
              <Col
                xl={6}
                className="d-flex justify-content-end align-items-center p-2 pe-4">
                <ImageButton
                  onClick={handleAddSampleLeave}
                  image={addIcon}
                  imageFocus={addIconFocus}
                  active={true}
                  width={32}
                />
              </Col>
              <Col>
                <ReactGridLayout
                  ref={sampleLeavesRef}
                  layout={sampleLeavesLayout}
                  items={sampleLeavesLayout.length}
                  rowHeight={48}
                  cols={1}
                  isResizable={false}
                  isDraggable={true}
                  isBounded={true}>
                  {sampleLeavesLayout.map((item) => {
                    return (
                      <div key={item["i"]}>
                        <ShiftCell
                          data={item.data}
                          isInteractive={true}
                          key={`ShiftCell_${item["i"]}`} />
                      </div>
                    )
                  })}
                </ReactGridLayout>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    else if (selectedMenu === menuList.indexOf("Jours fériés"))
      return <HolidaysTab menuLabel={menuList[selectedMenu]} />
    else if (selectedMenu === menuList.indexOf("Questionnaire d'évaluations"))
      // Re-enabled: this tab was commented out on 2026-02-27 (052b6fb9) and returned an
      // empty element, so there was no way to add an evaluation type or its questions
      // from the app at all. It is the entry point for configuring a type's prime
      // report, so it has to be reachable.
      return <Row className="m-0">
        <Col xxl={7}>
          <div className={styles.menuContent}>
            <Row className="p-2">
              <Col xl={6}
                className="d-flex justify-content-start align-items-center p-2 ps-4 mb-4 fw-bold">
                <label className={styles.menuHeaderTitle}>
                  <Langs str='TYPES' />
                </label>
              </Col>
              <Col
                xl={6}
                className="d-flex justify-content-end align-items-center p-2 pe-4 mb-4">
                <ImageButton
                  image={addIcon}
                  imageFocus={addIconFocus}
                  onClick={() => { dispatch(setTypeModalVisibilty(true)); }}
                  tooltip={<Langs str="ADD" />}
                  active={true}
                  width={32}
                />
              </Col>
              <Col lg={12}>
                {renderEvaluationTypes()}
              </Col>
            </Row>
          </div>
        </Col>
        <Col xxl={5} className="d-flex align-content-center ms-0 ps-0">
          <div className={styles.menuContentV}>
            <Row className="p-2">
              <Row>
                <Col
                  xl={6}
                  className="d-flex justify-content-start align-items-center p-2 ps-4 mb-4 fw-bold">
                  <label className={styles.menuHeaderTitle}>
                    <Langs str="QUESTIONS" />
                  </label>
                </Col>
                <Col
                  xl={6}
                  className="d-flex justify-content-end align-items-center p-2 pe-4 mb-4">
                  {!onAddEvaluationRowVisibility && selectedEvaluationTypeLocal &&
                    <ImageButton
                      image={addIcon}
                      imageFocus={addIconFocus}
                      onClick={handleAddEvaluationFieldVisibility}
                      tooltip={<Langs str="ADD" />}
                      active={true}
                      width={32}
                    />}
                </Col>
                <Dropdown
                  value={selectedEvaluationTypeLocal}
                  onChange={handleEvaluationTypeChange}
                  options={evaluationsTypes}
                  optionLabel="title"
                  placeholder="Type"
                  className="w-50 fw-semibold text-black ms-3 mb-3"
                  style={{ maxWidth: "100%" }}
                />
                {renderEvaluationFields()}
                {renderAddEvaluationRow()}
                {renderConfirmDeleteDialog()}
              </Row>
            </Row>
          </div>
        </Col>
        <EvaluationTypeModal />
        <EvaluationFieldModal />
      </Row>
    else if (selectedMenu === menuList.indexOf("Postes")) {
      return <PostesTab />
    }
    else if (selectedMenu === menuList.indexOf("Compétence")) {
      return <SkillsTab />
    }

  }

  if (isMobile == 2) {
    return (
      <div style={{ height: "100%", width: "100%", overflow: "auto" }}>
        <MobileSettingsView
          menuList={menuList}
          selectedMenu={selectedMenu}
          onMenuChange={(v) => setSelectedMenu(v)}
          onAddAction={() => mobileAddRef.current && mobileAddRef.current()}
          showAddButton={showMobileAddButton}
        >
          {renderMobileContent()}
        </MobileSettingsView>
        <ShiftFormModal
          show={showFormPopup}
          onHide={() => dispatch(hideFormPopup())}
          isMobile={isMobile}
        />
      </div>
    )
  }

  return (
    <div className={styles.settingsView}>
      <div>
        <div className={styles.leftMenu}>
          <label className={styles.leftMenuTitle}>
            <Langs str="Settings" />
          </label>
          {menuList.map((item, index) => (
            <button
              key={`MENU_${index}`}
              value={index}
              className={styles.settingsButton}
              onClick={() => setSelectedMenu(index)}
            >
              <div
                className={
                  item === menuList[selectedMenu]
                    ? styles.selectedLabel
                    : styles.menuLabel
                }
              >
                <Langs str={item} />
              </div>
            </button>
          ))}
          <label className={styles.versionLabel}>Version {pjson.version}</label>
        </div>
      </div>
      {renderMenuContent()}
      <ShiftFormModal
        show={showFormPopup}
        onHide={() => dispatch(hideFormPopup())}
      />
    </div>
  )
}
